import { getCurrentFormatTime } from "@/utils/date-format";
import React from "react";
import { YouXueSignUp } from "../../model";
import styles from "./index.module.less";

const BrandCardComp: React.FC<{
  className?: string | undefined;
  signUpDetail?: {
    /** 游学logo头像 */
    studyTourLogo?: string;
    /** 游学标题 */
    studyTourTitle?: string;
    /** 报销上限 */
    travelAllowance?: string;
    /** 省内差补贴费用（单位元）*/
    travelProvinceInAllowance?: string;
    /** 省外差补贴费用（单位元）*/
    travelProvinceOutAllowance?: string;
    /** 游学开始时间 */
    studyTourBeginTime?: string;
    /** 游学结束时间 */
    studyTourEndTime?: string;
  };
}> = ({ className, signUpDetail }) => {
  if (!signUpDetail) { return null; }

  const showTags = () =>
    `${signUpDetail?.travelAllowance ?? ""}${signUpDetail?.travelProvinceInAllowance ?? ""}${signUpDetail?.travelProvinceOutAllowance ?? ""}`.length > 0;

  return (
    <div className={styles.list__card + " " + className}>
      <img className={styles.card__image} src={signUpDetail?.studyTourLogo} />
      <div className={styles.card__content}>
        <div className={styles.content__title}>
          <div className={styles.title__left}>{signUpDetail?.studyTourTitle}</div>
        </div>
        {
          showTags() && (
            <div className={styles.tag__list}>
              {signUpDetail?.travelAllowance && (
                <div className={styles.item}>
                  <div className={styles.tag__txt}>
                    {signUpDetail?.travelAllowance}
                  </div>
                </div>
              )}
              {signUpDetail?.travelProvinceInAllowance && (
                <div className={styles.item}>
                  <div className={styles.tag__txt}>
                    {signUpDetail?.travelProvinceInAllowance}
                  </div>
                </div>
              )}
              {signUpDetail?.travelProvinceOutAllowance && (
                <div className={styles.item}>
                  <div className={styles.tag__txt}>
                    {signUpDetail?.travelProvinceOutAllowance}
                  </div>
                </div>
              )}
            </div>
          )}

        <div className={styles.content__desc}>
          {`游学活动时间：${getCurrentFormatTime(parseInt(signUpDetail?.studyTourBeginTime || "0", 10))}-${getCurrentFormatTime(parseInt(signUpDetail?.studyTourEndTime || "0", 10))}`}
        </div>
      </div>
    </div>
  );
};

export default BrandCardComp;;;;